module.exports = __webpack_public_path__ + "assets/img/101211.0d978bba.svg";